import { useParams } from 'react-router-dom'
import React, { Suspense, lazy } from 'react'
// Remove static import of PlatformPage
// import { PlatformPage } from '@/pages/PlatformPage'

const PlatformPage = lazy(() => import('@/pages/PlatformPage').then(module => ({ default: module.PlatformPage })))

export const CountryPlatformRoute: React.FC = () => {
    const { slug } = useParams<{
        slug: string
    }>()

    // The I18nProvider now handles country switching automatically based on the URL
    // Just render the PlatformPage with the extracted slug
    return (
        <Suspense fallback={null}>
            <PlatformPage slug={slug} />
        </Suspense>
    )
} 